<template>
  <g>
    <g clip-path="url(#clip0_15_553)">
      <path
        d="M19.37 10.0402C18.68 6.59024 15.65 4.00024 12.01 4.00024C9.12001 4.00024 6.61001 5.64024 5.36001 8.04024C2.35001 8.36024 0.0100098 10.9102 0.0100098 14.0002C0.0100098 17.3102 2.70001 20.0002 6.01001 20.0002H19.01C21.77 20.0002 24.01 17.7602 24.01 15.0002C24.01 12.3602 21.96 10.2202 19.37 10.0402Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_553">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.000244141)"
        />
      </clipPath>
    </defs>
  </g>
</template>
